import styled from "styled-components";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { NavLink } from "react-router-dom";
import {
  isMobile,
  isMobileOnly,
  isDesktop,
  isTablet,
} from "react-device-detect";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
/* import PageContentBgABCDark from "../../../abc/src/data/img/header_bg_mobile_dark.jpg";
import PageContentBgABCWhite from "../../../abc/src/data/img/header_bg_mobile_light.jpg"; */
import { ReactComponent as MoneyBag } from "./../assets/icon-component/moneybag_icon.svg";
import { ReactComponent as CalendarRed } from "./../assets/icon-component/calendar_end.svg";
import { ReactComponent as CalendarGreen } from "./../assets/icon-component/calendar_start.svg";

export const PageContent = styled.div.attrs((props) => ({
  className: props.bg ? "bg" : "",
}))`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  background-color: ${({ about, account }) =>
    about
      ? "var(--pageContentHeaderAboutBgColor)"
      : !isMobileOnly && account
        ? "var(--pageContentHeaderAccountBgColor)"
        : isMobileOnly
          ? "var(--pageContentHeaderMobileBgColor)"
          : "var(--pageContentHeaderBgColor)"};

  min-height: ${({ profileABC, ingamedep }) =>
    profileABC
      ? isMobileOnly
        ? "100px"
        : "calc(100vh - 560px)"
      : ingamedep
        ? "40vh"
        : "var(--pageContentMinHeight)"};

  background-image: ${({ account, nobg }) => {
    if (!account) return ``;
    if (isMobile && nobg) return `var(--pageContentBgImageAccountMobile)`;
    if (nobg) return `var(--pageContentBgImageAccountNobg)`;
    return `var(--pageContentBgImageAccount)`;
  }};
  background-repeat: var(--pageContentMainBgRepeat);
  background-position: ${({ cashback }) =>
    cashback ? "bottom" : "var(--pageContentMainBgPosition)"};
  background-size: ${({ account, cashback, responsible }) =>
    account
      ? isMobile
        ? "var(--pageContentBgSizeAccountMobile)"
        : cashback
          ? "100%"
          : "var(--pageContentBgSizeAccountDesktop)"
      : isMobile
        ? "var(--pageContentBgSizeNoAccountMobile)"
        : responsible
          ? "var(--pageContentBgSizeNoAccountResponsible)"
          : "var(--pageContentBgSizeNoAccountDesktop)"};
  background: ${({ theme, account }) =>
    theme.skin === "fun" &&
    !account &&
    "linear-gradient(180deg,rgba(0, 175, 216, 1) 15%, rgba(68, 194, 206, 1) 77%)"};

  //margin: 40px 0 40px 0;

  &.bg {
    align-items: ${({ about, account }) =>
      about || account ? "var(--pageContentBgAlignItems)" : "center"};
    min-height: ${({ land, ingamedep }) =>
      ingamedep
        ? ""
        : land
          ? "var(--pageContentBgMinHeightLand)"
          : "var(--pageContentBgMinHeight)"};
    background-position: ${({ dep }) =>
      dep ? "var(--pageContentBgPositionDep)" : "var(--pageContentBgPosition)"};
    background-repeat: no-repeat, no-repeat !important;
    background-attachment: var(--pageContentBgAttachment);
    flex-wrap: var(--pageContentFlexWrap);
    padding-top: ${({ ingamedep }) =>
      isMobileOnly && !ingamedep && "var(--pageContentBgPaddingTop)"};
    background-size: ${({ dep, payments, theme }) => {
      if (theme.skin === "pub") {
        return isMobile ? "auto !important" : "100% 110% !important";
      }
      if (dep) {
        if (payments) return "100%";
        return `var(--pageContentBgSizeDep)`;
      }
      return `var(--pageContentBgSize)`;
    }};
    background-color: ${({ payments }) =>
      payments
        ? "var(--pageContentBgPaymentsBgColor)"
        : "var(--pageContentBgBgColor)"};
    background-image: ${({ theme, ingamedep, clear }) => {
      if (ingamedep && (isMobile || theme.skin === "rac")) return ``;
      return clear
        ? `var(--pageContentBgPubClearBg)`
        : `var(--pageContentBgPubBg)`;
    }};
  }
  &.land {
    min-height: 100%;
  }
  @media screen and (orientation: landscape) {
    padding: ${({ ingamedep }) =>
      !isDesktop && !ingamedep && "var(--pageContentLandscapePadding)"};
  }
`;

export const PageContentWrapper = styled.div`
  margin: ${({ verification, theme }) => verification && "auto"};
  .form-group {
    margin-bottom: var(--pageContentWrapperFormGroupMb);
  }
  z-index: 4;
  width: 100%;

  @media (max-width: 767px) {
    .btn-first {
      font-size: 0.8rem;
      padding-right: var(--pageContentWrapperBtnPaddingRight);
    }
  }
`;

export const AccountContainer = styled.div.attrs((props) => ({
  className: props.vh ? "min-vh-100 container" : "container",
}))`
  display: ${({ sports }) => sports && "flex"};
  flex-wrap: ${({ sports }) => sports && "wrap"};
  margin-bottom: var(--accountContainerMarginBottom);

  iframe {
    height: var(--accountContainerIframeHeight);
  }
  ${(props) => {
    if (props.container) {
      return `
      @media (max-width: 767px) {
        margin: var(--accountContainerContainerMobileMargin);
      }
      margin: ${
        (props.theme.skin === "pub" ||
          props.theme.skin === "cac" ||
          props.theme.skin === "hyc") &&
        isMobileOnly &&
        "8rem 0 2rem 0"
      };
      `;
    }
    if (props.mt) {
      return `
      margin-top: ${
        isMobileOnly ? "5vh" : "var(--accountContainerMtMarginTop)"
      };
      max-width: 1024px !important;
      color: var(--acolor);
      `;
    }
    if (props.limits) {
      return `
        max-width: 1024px !important;
        color: var(--acolor);

        .nav-link {
          margin-right: 0;
        }
        @media (max-width: 767px) {
          .btn-first {
          margin: var(--accountContainerLimitsBtnMargin);
        }
        }
      `;
    }
    if (props.history) {
      return `
            max-width: 1024px !important;
            color: var(--acolor);
            margin: 4rem auto;
            padding-bottom: ${
              !isMobile &&
              !props.tournaments &&
              "var(--accountContainerHistoryPaddingBottom)"
            };
           
            
            `;
    } else {
      if (props.theme.skin === "rac") {
        return `
        /* max-width: 1024px !important;
        color: var(--acolor);

        .nav-link {
        }
        @media (max-width: 767px) {
          .btn-first {
          margin: 1rem;
        }
        } */
      `;
      } else {
        return `
            max-width: ${
              props.lending
                ? "90% !important"
                : props.tournaments
                  ? ""
                  : "1024px !important"
            };
            color: var(--acolor);
        
            input[type='text'] {
                font-weight: var(--accountContainerInputFontWeight);
                text-align: right;
                width: 60%;
                padding: 0;
                height: var(--accountContainerInputHeight);
                background-color: transparent;
            }
            .invalid-feedback {
                position: var(--accountContainerInvalidFeedbackPosition);
                top: var(--accountContainerInvalidFeedbackTop);
            }
            label {
                font-weight: var(--accountContainerLabelFontWeight);
                width: 40%;
            }
            select {
                text-align: right;
                font-weight: var(--accountContainerLabelFontWeight);
                -webkit-appearance: none;
                -moz-appearance: none;
                text-indent: 1px;
                text-overflow: '';
                background-color: transparent;
                width: 40px !important;
                padding: 0;
                text-align-last: right;
                cursor: pointer;
                direction: rtl;
            }
            select:focus {
                background-color: transparent;
            }
        
            @media (max-width: 767px) {
                padding-left: var(--accountContainerMobilePaddingInline) !important;
                padding-right: var(--accountContainerMobilePaddingInline) !important;
        
                input[type='text'] {
                height: 50px;
                font-size: 0.8rem;
                }
                select {
                width: 40px;
                height: 50px;
                text-align: right;
                text-align-last: right;
                padding: 0;
                font-size: 0.8rem;
                }
                label {
                margin-bottom: 0;
                font-size: 0.7rem;
                }

                button {
                  span {
                    font-size: ${
                      isMobileOnly ? "1rem !important" : "1.6rem !important"
                    };
                    color: var(--accountContainerSpanColor);
                  }
                }
            }
            @media (min-width: 768px) and (max-width: 1024px) {
                padding: 0 2rem !important;
        }
            `;
      }
    }
  }}
  input[type="text"]:disabled {
    color: var(--acolor);
    background-color: transparent;
  }
  video {
    padding: 15px;
  }
`;

export const AccountHeader = styled.h1.attrs((props) => ({
  className: props.transactions ? "text-left" : "",
}))`
  color: var(--acolor);
  text-align: left;
  font-size: var(--accountHeaderFontSize);
  margin: 30px 0;
  font-weight: ${(props) =>
    props.transactions ? "var(--accountHeaderFontWeight)" : "900"};
  text-transform: var(--accountHeaderTextTransform);

  @media (max-width: 926px) {
    margin-top: 0;
  }
`;

export const TabContent = styled.div.attrs((props) => ({
  className: props.limits ? (props.rac ? "border rounded" : "pt-5") : "",
}))`
  color: var(--tabContentColor);
  ${(props) => {
    if (props.spanSize) {
      return `
        text-align: justify !important;
        text-justify: auto !important;
        p {
            font-size: 1.1rem !important;
            line-height: 1.6 !important;
            color: var(--acolor);
            font-weight: 500 !important;
            letter-spacing: 0.5px;
            background: var(--tabContentSpanSizeBg);

        }
        h2 {
            color: var(--tabContentH2Color);
            font-weight: 800;
        }
        .text-bottom ul,
        .text-bottom ol {
            li {
            font-size: 12px;
            color: var(--tabletext);
            }
        }
        @media (max-width: 767px) {
            p {
                line-height: 1.5 !important;
                font-size: 1rem !important;
            }
        }
            `;
    } else {
      return `
        text-align: left;
        p {
            color: var(--tabContentPColor);
            line-height: 1.8 !important;
            font-size: 12px;
            letter-spacing: 0.5px;
        }
        .text-bottom ul,
        .text-bottom ol {
            li {
            font-size: 12px;
            color: var(--tabContentLiColor);
        }
        @media (max-width: 767px) {
            p {
                line-height: 1.5 !important;
            }
        }
        `;
    }
  }}
`;

export const AccountDescription = styled.div`
  font-size: var(--accountDescriptionFontSize);
  line-height: 1.8;
  color: var(--accountDescriptionColor);
  text-align: justify;
  align-items: var(--accountDescriptionAlignItems);
  margin: ${isMobileOnly ? "1rem 0" : "var(--accountDescriptionMargin)"};

  h5 {
    background: ${({ expand }) =>
      expand ? "" : !isMobileOnly ? "" : `var(--accountDescriptionH5Bg)`};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: ${({ expand }) =>
      expand ? "" : !isMobileOnly ? "" : "transparent"};
    font-size: 1rem;
    font-weight: 500;
    color: var(--accountDescriptionH5Color);
  }
  p {
    color: ${({ about }) =>
      about
        ? "var(--accountDescriptionPAboutColor)"
        : "var(--accountDescriptionPColor)"};
    font-weight: 400;
    font-size: var(--accountDescriptionPFontSize);
  }
  h3 {
    color: var(--accountDescriptionH3Color);
    font-size: 1.2rem;
    text-align: left;
    font-weight: 900;
  }
  h2 {
    color: var(--accountDescriptionH2Color);
    text-align: left;
    font-weight: var(--accountDescriptionH2FontWeight);
    font-size: ${isMobileOnly
      ? "1.3rem"
      : "var(--accountDescriptionH2FontSize)"};
    padding: var(--accountDescriptionH2Padding);
    margin: var(--accountDescriptionH2Margin);
    letter-spacing: 0px;
    font-family: ${({ about }) =>
      about && "var(--accountDescriptionH2FontFamily)"};
    text-transform: var(--accountDescriptionH2TextTransform);
  }
  ol,
  li {
    color: var(--accountDescriptionLiColor);
    font-size: var(--accountDescriptionLiFontSize);
  }
  .answer::before {
    content: "&nbsp;";
    font-size: 0;
    display: block;
    line-height: 0;
  }

  .accordion {
    font-weight: 600;
    padding: 1rem 0;

    :hover {
      color: var(--accountDescriptionAccordionHoverColor);
      cursor: pointer;
    }
  }
  .indent {
    color: var(--pcolor);
    margin-left: 1rem;
  }
  a {
    text-decoration: underline;
  }
  h4 {
    font-size: 0.8rem;
    text-align: var(--accountDescriptionH4TextAlign);
    color: var(--accountDescriptionH4Color);
  }

  @media (max-width: 767px) {
    height: ${({ expand }) =>
      expand
        ? "var(--accountDescriptionExpandHeight)"
        : "var(--accountDescriptionCollapsedHeight)"};
    overflow: var(--accountDescriptionMobileOverflow);

    font-size: 1rem;
    line-height: 1.5;
    h3 {
      line-height: 1.5;
    }
    .indent {
      margin-left: 0.5rem;
    }
  }
`;

export const TransactionDescription = styled.div`
  h3 {
    font-size: 1.3rem;
    font-weight: 600;
  }
  text-align: justify;
  ${(props) => `
        padding: var(--transactionDescriptionPadding);
        p {
          font-size: var(--transactionDescriptionPFontSize);
          color: var(--transactionDescriptionPColor);
          font-size: ${props.affedd ? "var(--transactionDescriptionAffeddFontSize)" : ""};
          font-weight: var(--transactionDescriptionPFontWeight);
        }
        h2 {
          color: var(--acolor);
        }
        font-size: ${props.affedd ? "1.2rem" : ""}
  `}
`;

export const StyledTabs = styled(Tabs).attrs((props) => ({
  className:
    props.theme.skin === "rac"
      ? props.limits
        ? ""
        : "my-3 p-4 border rounded"
      : "",
}))``;

export const StyledTabList = styled(TabList).attrs((props) => ({
  className:
    props.theme.skin === "rac"
      ? props.limits
        ? "nav justify-content-center py-4"
        : "nav my-3 justify-content-center"
      : props.limits
        ? "nav justify-content-around py-4 text-capitalize"
        : `nav my-3 justify-content-center ${
            props.theme.skin !== "abc" &&
            props.theme.skin !== "nbc" &&
            props.theme.skin !== "qbc" &&
            "mt-5"
          } py-3`,
}))`
  background: var(--styledTabListBackground);
  align-items: center;
`;

export const StyledTab = styled(Tab).attrs((props) => ({
  className: "nav-link",
}))`
  transition: background-color 0.2s ease-in;
  font-family: var(--styledTabFontFamily);
  font-weight: var(--styledTabFontWeight);
  font-size: var(--styledTabFontSize);
`;

export const StyledTabPanel = styled(TabPanel).attrs((props) => ({
  className: `flex-table ${
    props.theme.skin === "rac"
      ? props.racgdpr && isMobile
        ? "justify-content-around"
        : ""
      : ""
  }`,
}))``;

export const TextBottom = styled.div.attrs((props) => ({
  className: props.open ? "open" : "",
}))`
  text-shadow: ${!isMobileOnly ? "var(--textBottomTextShadow)" : "none"};
  font-size: var(--textBottomFontSize);
  font-weight: var(--textBottomFontWeight);
  min-height: 350px;
  line-height: 1.8;
  color: var(--textBottomColor);
  padding-top: ${isMobileOnly ? "1rem" : "4rem"};

  ol {
    padding: 2rem 1rem 4rem 1rem;

    li {
      text-align: var(--textBottomOlLiTextAlign);
    }
  }
  .bullet {
    margin-left: 2rem;
    li {
      display: list-item;
      list-style-type: circle !important;
    }
  }
  ul {
    padding-left: 0;
    li {
      display: inline-block;
      margin-right: 5px;
      font-size: var(--textBottomUlLiFontSize);
      color: var(--textBottomUlLiColor);
    }
  }
  &.open {
    margin-bottom: var(--textBottomOpenMarginBottom);
  }
  h2 {
    color: var(--acolor);
    text-align: var(--textBottomH2TextAlign);
    font-weight: var(--textBottomH2FontWeight);
    text-transform: var(--textBottomH2TextTransform);
    font-size: var(--textBottomH2FontSize);
  }
  h3 {
    text-align: var(--textBottomH3TextAlign);
    color: var(--acolor);
    margin: var(--textBottomH3Margin);
    font-size: var(--textBottomH3FontSize);
  }
  @media (max-width: 926px) {
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 500;

    h3 {
      line-height: 1;
    }
    ul {
      li {
        /* font-size: 1rem !important; */
      }
    }

    ul,
    ol {
      li {
        text-align: var(--textBottomMobileLiTextAlign);
        font-size: 12px;
        color: var(--textBottomMobileLiColor);
      }
    }
  }
`;

export const StyledCol = styled.div.attrs((props) => ({
  className: "col",
}))`
  padding: ${(props) => (props.spanPadding ? "0 !important" : "")};
`;

export const StyledAccontH1 = styled.h1`
  color: var(--acolor);
  text-align: left;
  font-size: 2rem;
  margin: 30px 0;
  font-weight: 900;

  @media (max-width: 926px) {
    margin-top: 0;
  }
`;

export const AccountCustomFormInline = styled.div.attrs({
  className: "form-inline",
})`
  margin: var(--accountCustomFormInlineMargin);
  padding: var(--accountCustomFormInlinePadding);
  background: var(--accountCustomFormInlineBg);

  label {
    justify-content: left;
  }
  @media (max-width: 767px) {
    margin: var(--accountCustomFormInlineMobileMargin);
  }
`;

export const StyledUserName = styled.div`
  font-size: 2rem;
  color: var(--styledUserNameColor);
  font-weight: 600;

  @media (max-width: 767px) {
    font-size: 1.2rem;
  }
`;

export const MyProfileButton = styled.button.attrs({
  className: "btn btn-first col-md-2 ml-auto",
})`
  width: 100px !important;
  background: var(--myProfileButtonBgColor);
  color: var(--myProfileButtonColor);
  border: var(--myProfileButtonBorder);
  border-radius: var(--myProfileButtonBorderRadius);

  :hover {
    border-color: var(--myProfileButtonHoverBorderColor);
    color: var(--myProfileButtonHoverColor);
  }
`;

export const AccountCol = styled.div.attrs((props) => ({
  className: "col-sm",
}))`
  text-transform: var(--accountColTextTransform);
  input {
    text-transform: var(--accountColTextTransform);
  }
  select {
    text-transform: var(--accountColTextTransform);
  }
`;
export const StyledFormRow = styled.div.attrs((props) => ({
  className: `form-row ${props.extra && props.extra}`,
}))`
  max-width: ${({ zignsecFrame }) => zignsecFrame && "535px !important"};
  margin: ${({ zignsecFrame }) => zignsecFrame && "auto !important"};
  padding-top: ${({ zignsecFrame }) =>
    zignsecFrame && !isMobileOnly && "var(--styledFormRowZignsecPaddingTop)"};
  ${(props) => {
    if (props.nbcstepone && isMobileOnly) {
      return `
      .form-group {
        padding-left: 0;
        padding-right: 0;
      }
      `;
    }
  }}
  .form-inline {
    label {
      justify-content: left;
    }
  }
  .form-group.col-md-12 {
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type="number"] {
      -moz-appearance: textfield;
      appearance: textfield;
    }
  }
  @media (max-width: 767px) {
    margin: 0rem !important;
  }
`;

export const BirthdayWrapper = styled.div`
  color: var(--birthdayWrapperColor);
  padding-top: var(--birthdayWrapperPaddingTop);
  height: 35px;
  line-height: var(--birthdayWrapperLineHeight);
  font-weight: var(--birthdayWrapperFontWeight);
  text-transform: var(--birthdayWrapperTextTransform);
  font-size: var(--birthdayWrapperFontSize);
`;

export const StyledFormWrapper = styled.div.attrs((props) => ({
  className: props.mobileLandscape
    ? "form-inline text-left col-sm mx-2"
    : "form-inline text-left col-sm",
}))`
  text-transform: var(--styledFormWrapperTextTransform);
  input {
    text-transform: var(--styledFormWrapperTextTransform);
    width: var(--styledFormWrapperInputWidth);
  }
  label {
    color: var(--styledFormWrapperLabelColor);
    font-weight: var(--styledFormWrapperLabelFontWeight);
  }
  ${(props) => {
    if (props.editButton) {
      return `
        border-bottom: var(--styledFormWrapperEditBorderBottom);
        input {
          border: var(--styledFormWrapperEditInputBorder);
        }
        padding: 0 !important;

        @media (max-width: 767px) {
            /* height: 50px; */
        }
    `;
    }
  }}
  border-bottom: ${(props) =>
    props.spanborderbottom ? `var(--styledFormWrapperSpanBorderBottom)` : ""};
  padding: ${(props) =>
    props.spanborderbottom ||
    props.theme.skin === "fun" ||
    props.theme.skin === "cac" ||
    props.theme.skin === "hyc" ||
    props.theme.skin === "rac" ||
    props.theme.skin === "qbc" ||
    props.theme.skin === "bec"
      ? "0 !important"
      : ""};

  label {
    justify-content: left !important;
  }

  @media (max-width: 767px) {
    margin: 0rem !important;
  }
`;

export const StyledFormLastRow = styled.div.attrs((props) => ({
  className: "form-inline text-left col-sm",
}))`
  text-transform: var(--styledFormLastRowTextTransform);
  label {
    justify-content: left !important;
  }
  select {
    text-transform: var(--styledFormLastRowTextTransform);
    height: var(--styledFormLastRowSelectHeight);
  }
  ${(props) => {
    if (props.disabled) {
      return `
        label {
          width: calc(100% - 40px);
        }
        padding: 0 !important;
        select {
          cursor: default;
        }
           border-bottom: var(--styledFormLastRowDisabledBorderBottom);
      `;
    } else if (!props.editButton) {
      return `
        border-bottom: var(--styledFormLastRowNotEditBorderBottom);
        select {
          border: var(--styledFormLastRowSelectBorder);
        }
        padding: 0 !important;
        
        label {
            width: calc(100% - 40px);
        }
        @media (max-width: 767px) {
        /* height: 50px; */
        }
      `;
    } else {
      return `
        label {
            width: calc(100% - 40px);
        }
        border-bottom: var(--styledFormLastRowEditBorderBottom);
        padding: 0 !important;
        select {
          cursor: default;
        }
      `;
    }
  }}
`;
export const CashbackCountdown = styled.div`
  font-size: 1.3vh;
  background-repeat: no-repeat;
  background-position: center;
  color: var(--labelcolor);
  font-weight: 700;
  border-radius: 8px;
  padding: 4rem 0;
  margin: 0 auto;
  width: 600px;

  .btn-activate {
    text-transform: capitalize;
    height: var(--cashbackCountdownBtnHeight);
    font-size: var(--cashbackCountdownBtnFontSize);
    &:disabled:hover {
      border-color: inherit;
      background-color: var(--cashbackCountdownBtnDisabledBgColor);
      color: var(--cashbackCountdownBtnDisabledColor);
    }
  }
  @media (max-width: 576px) {
    width: 100%;
    padding: 2rem 0;

    .btn-activate {
      text-transform: capitalize;
      height: 40px;
      font-size: 0.6rem;
      width: var(--cashbackCountdownBtnMobileWidth);
    }
  }
`;

export const BackgroundWrapperCashback = styled.div`
  width: 100%;
  border-top: var(--backgroundWrapperCashbackBorderTop);
  border-bottom: var(--backgroundWrapperCashbackBorderBottom);
  border-left: var(--backgroundWrapperCashbackBorderSide);
  border-right: var(--backgroundWrapperCashbackBorderSide);
`;

export const StyledTextCenter = styled.div.attrs((props) => ({
  className: `text-center ${props.padding}`,
}))``;

export const StyledClock = styled.div`
  text-align: center;
  text-transform: var(--styledClockTextTransform);
  font-weight: var(--styledClockFontWeight);
  color: var(--styledClockColor);
`;

export const StyledClockWrapper = styled.div`
  color: var(--styledClockWrapperColor);
  font-family: var(--styledClockWrapperFontFamily);
  font-weight: var(--styledClockWrapperFontWeight);
`;

export const DepositAndCashbackWrapper = styled.div.attrs({
  className: "row justify-content-between",
})`
  width: var(--depositAndCashbackWrapperWidth);
  margin: 0 auto;
  font-weight: 500;
  color: var(--depositAndCashbackWrapperColor);
  padding-bottom: 0.5rem;
`;

export const TotalDepositWrapper = styled.div.attrs({
  className: "text-left align-self-end col-md-3 col-sm-12",
})``;

export const DepositAndCashback = styled.div`
  font-size: var(--depositAndCashbackFontSize);
  font-weight: 900 !important;
  color: var(--depositAndCashbackColor);

  @media (max-width: 576px) {
    font-size: 5vw;
  }
`;

export const TotalCashbackWrapper = styled.div.attrs({
  className: "text-right col-md-4 col-sm-12",
})``;

export const RedeemCashback = styled.div.attrs({
  className: "col-6 align-self-center text-uppercase mx-auto",
})``;

export const CashbackButton = styled.button.attrs((props) => ({
  className: isMobileOnly
    ? props.theme.skin === "abc"
      ? "mt-5 btn btn-first w-200 btn-activate"
      : "btn btn-first w-200 btn-activate btn-border"
    : "mt-5 btn btn-first w-200 btn-activate btn-border",
}))`
  font-size: var(--cashbackButtonFontSize);
`;

export const ChangePasswordWrapper = styled.div.attrs((props) => ({
  className: `col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2 ${
    props.theme.skin === "abc" && isMobile ? "mt-5" : ""
  }`,
}))``;

export const ChangeInputWrapper = styled.div.attrs((props) => ({
  className: props.button
    ? "form-group text-center col-md-10"
    : "form-group text-left col-md-10",
}))`
  margin: 0 auto;
  float: none;
  margin-bottom: 1.5rem !important;
`;

export const ChangePassButton = styled.button.attrs({
  className: "btn btn-first col-md-7 my-3",
})`
  ${(props) => {
    if (props.pub) {
      return `
        border: ${props.goldenborder ? "2px solid #9A875D" : "2px solid #fff"};
        border-radius: 0.3rem;
        cursor: pointer;
  
        &:hover {
          border-color: ${props.goldenborder ? "#fff" : "#9A875D"};
        }
        &:disabled {
          &:hover {
            border-color: #fff;
          }
        }
        `;
    }
  }}
`;

export const InvalidFeedback = styled.div.attrs({
  className: "invalid-feedback",
})`
  top: ${({ abc }) => abc && "1.7rem !important"};
  position: ${({ reg }) => (reg ? "absolute" : "absolute")};
  display: ${({ reg }) => (reg ? "block" : "")};
  left: ${({ tel }) => (tel ? "15px" : "")};
  bottom: ${({ reg, tel }) => (reg ? (tel ? "3rem" : "-1rem") : "")};

  @media (max-width: 767px) {
    bottom: ${({ reg, tel }) => (reg ? (tel ? "2.5rem" : "-1rem") : "")};
    left: ${({ tel }) => (tel ? "20px" : "")};
  }
`;

export const TransactionsButtonWrapper = styled.div.attrs((props) => ({
  className: `d-flex justify-content-between py-4`,
}))`
  font-size: 1.1rem;
  line-height: 1.6;
  color: var(--acolor);
  font-weight: 700;
  text-align: justify;
  background: var(--transactionsButtonWrapperBg);
  align-items: var(--transactionsButtonWrapperAlignItems);
  border-bottom: var(--transactionsButtonWrapperBorderBottom);
  margin-top: ${!isMobileOnly && "4rem"};

  .flex-table-cell-content {
    font-weight: 500;
  }

  @media (max-width: 767px) {
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 600;
    flex-wrap: wrap;
    align-items: var(--transactionsButtonWrapperAlignItems);
  }
`;

export const TransactionsDescription = styled.span`
  font-weight: 300;
  font-size: var(--transactionsDescriptionFontSize);
  justify-content: var(--transactionsDescriptionJustifyContent);
  display: var(--transactionsDescriptionDisplay);
`;

export const TransactionButton = styled.button.attrs({
  className: "btn btn-first",
})`
  width: 140px !important;
  font-size: 0.8rem !important;
  border: var(--transactionButtonBorder);
  border-radius: var(--transactionButtonBorderRadius);
  margin-left: 1rem;

  :hover {
    border-color: var(--transactionButtonHoverBorderColor);
  }

  @media (max-width: 767px) {
    margin: 1rem 0 0 0;
  }
`;

export const GameTransactionWrapper = styled.div.attrs({
  className: "flex-table-row justify-content-center mt-3 mb-3",
})`
  align-items: var(--gameTransactionWrapperAlignItems);
`;

export const DatePickerWrapper = styled.div.attrs({
  className: "form-group d-flex flex-column col-md-4",
})``;

export const StyledDatePicker = styled(DatePicker).attrs((props) => ({
  className: props.register ? "form-control register-calendar" : "form-control",
}))`
  /* background-color: transparent; */
  input {
    background-color: transparent !important;
  }
  .react-calendar {
    background-color: var(--styledDatePickerCalendarBg);
    border: none;
    -webkit-box-shadow: 0px 0px 10px -2px var(--headerbg);
    box-shadow: 0px 0px 10px -2px var(--headerbg);
    border-radius: 0.5rem;
    margin-top: 1rem;

    button:hover {
      background-color: #1087ff;
    }
  }
  .react-date-picker__inputGroup {
    text-align: center;
  }
  .react-calendar__month-view {
    padding-bottom: 0.5rem;
  }
  // Frame style(wrapper)
  .react-date-picker__wrapper {
    input {
      color: var(--acolor);
    }
    border: none;
    align-items: center;
    height: 100%;
  }
  .react-calendar__calendar {
    inset: 100% auto auto 0px !important;
  }
  // SVG icon for calendar
  .react-date-picker__button {
    svg {
      stroke: var(--acolor) !important;
    }
  }
  .react-calendar__button {
    padding: 0 0px 0 0;
  }
  // Select range that hovers over dates style
  .react-calendar--selectRange .react-date-picker__tile--hover {
    background-color: #1087ff;
    color: #fff;
  }
  .react-calendar__navigation {
    button {
      color: var(--acolor);
      background-color: transparent;
      :focus {
        background-color: #1087ff;
      }
      :hover {
        background-color: #1087ff;
      }
    }
  }
  .react-calendar__month-view__days__day--weekend:disabled {
    color: gray !important;
  }
  .react-calendar__month-view__days__day {
    color: var(--acolor);
  }
  .react-calendar__month-view__days__day--weekend {
    color: red !important;
  }
  .react-calendar__tile {
    color: var(--acolor);
    border: none;
    background-color: var(--inputbgABC);

    :hover {
      background-color: #1087ff;
    }
  }
  // Month, Year, Decate View style
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    text-transform: capitalize;
    border: none;
  }
  // Month in navigation style
  .react-calendar__navigation__label__labelText {
    text-transform: capitalize;
  }
  // Month in navigation HOVER style
  .react-calendar__tile__navigation__label:hover {
    background-color: #1087ff;
  }
  //Title style dissabled
  .react-calendar__tile:disabled {
    background-color: transparent;
    color: gray;

    &:hover {
      background-color: transparent;
    }
  }
`;

export const StyledDateRangePicker = styled(DateRangePicker).attrs((props) => ({
  className: "custom-input number",
}))`
  width: 350px;
  border: var(--styledDateRangePickerBorder);
  color: var(--acolor);
  ${(props) => {
    if (props.choseDate) {
      return `
      .react-calendar:after {
        content: "${props.choseDate}";
        color: gray;
      }
      
      `;
    }
  }}

  // Global styled for callendar
  .react-calendar {
    background-color: var(--styledDateRangePickerCalendarBg);
    border: none;
    -webkit-box-shadow: 0px 0px 10px -2px var(--headerbg);
    box-shadow: 0px 0px 10px -2px var(--headerbg);
    border-radius: 0.5rem;
    margin-top: 1rem;
    padding-bottom: 0.5rem;
    button:hover {
      background-color: #1087ff;
      color: var(--styledDateRangePickerBtnHoverColor);
    }
  }
  .react-calendar__month-view {
    padding-bottom: 0.5rem;
  }
  // Frame style(wrapper)
  .react-daterange-picker__wrapper {
    border: none;
    align-items: center;
    height: 100%;
  }
  .react-daterange-picker__calendar {
    inset: 100% auto auto 0px !important;
  }
  // SVG icon for calendar
  .react-daterange-picker__calendar-button {
    svg {
      stroke: var(--acolor) !important;
    }
  }
  .react-calendar__month-view__days__day {
    color: var(--acolor);
  }
  .react-calendar__month-view__days__day--weekend:disabled {
    color: gray !important;
  }
  .react-calendar__month-view__days__day--weekend {
    color: red !important;
  }
  .react-calendar__tile {
    color: var(--acolor);
    border: none;
    background-color: var(--styledDateRangePickerTileBg);
    padding: 10px;

    :hover {
      background-color: #1087ff;
    }
  }
  .react-daterange-picker__button {
    padding: 0 0px 0 0;
  }
  // Select range that hovers over dates style
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #1087ff;
    color: #fff;
  }
  .react-daterange-picker__inputGroup__input {
    color: var(--acolor);
  }
  .react-calendar__navigation {
    button {
      border: none;
      color: var(--acolor);
      background-color: transparent;
      padding: 10px;
      :focus {
        background-color: #1087ff;
      }
      :hover {
        background-color: #1087ff;
      }
    }
  }
  // Month, Year, Decate View style
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    text-transform: capitalize;
  }
  // Month in navigation style
  .react-calendar__navigation__label {
    text-transform: capitalize;
  }
  // Month in navigation HOVER style
  .react-calendar__navigation__label:hover {
    background-color: #1087ff;
  }
  //Title style dissabled
  .react-calendar__tile:disabled {
    background-color: transparent;
    color: gray;

    &:hover {
      background-color: transparent;
    }
  }
`;

export const GameTransactionButtonWrapper = styled.div.attrs({
  className: "form-group col-md-3",
})``;

export const GameTransactionButton = styled.div.attrs({
  className: `btn btn-first w-100 ${isMobileOnly && "mt-5"}`,
})`
  border: var(--gameTransactionButtonBorder);
  border-radius: var(--gameTransactionButtonBorderRadius);

  :hover {
    border-color: var(--gameTransactionButtonHoverBorderColor);
  }
`;

export const GameHistoryWrapper = styled.div.attrs((props) => ({
  className: "flex-table-row flex-table-row-header",
}))`
  border-bottom: var(--gameHistoryWrapperBorderBottom);
`;

export const TableHeader = styled.div.attrs((props) => ({
  className: `flex-table-cell title-content ${props.col}`,
}))`
  text-align: ${isTablet && "var(--tableHeaderTextAlign)"};
  color: ${({ theme, color }) =>
    color ? "black !important" : theme.skin === "pub" && "#9A875D !important"};
`;

export const TransactionNotFound = styled.div.attrs((props) => ({
  className: `flex-table-row justify-content-center p-3 `,
}))`
  color: var(--transactionNotFoundColor);
`;

export const StyledTableRow = styled.div.attrs((props) => ({
  className: `flex-table-row ${
    props.theme.skin === "pub" ||
    props.theme.skin === "cac" ||
    props.theme.skin === "hyc"
      ? "border-bottom"
      : ""
  }`,
}))`
  ${(props) => {
    if (props.financial) {
      return `
            font-size: var(--styledTableRowFontSize);
            line-height: 1.6;
            color: var(--acolor);
            font-weight: 700;
            text-align: justify;

            .flex-table-cell-content {
                font-weight: var(--styledTableRowContentFontWeight);
                font-size: var(--styledTableRowContentFontSize);
            }
            @media (max-width: 767px) {
                font-size: 1rem;
                line-height: 1.5;
                font-weight: 600;
                flex-wrap: wrap;
            }
            `;
    }
  }};
`;

export const StyledTransactionWrapper = styled.div`
  min-height: var(--styledTransactionWrapperMinHeight);
`;

export const StyledTableCell = styled.div.attrs((props) => ({
  className: `flex-table-cell ${props.cell} col-sm-12 ${props.col}`,
}))`
  @media (max-width: 767px) {
    .flex-table-cell-heading {
      flex: 0;
    }
  }
`;

export const StyledTableContent = styled.div.attrs({
  className: "flex-table-cell-content text-capitalize",
})`
  ${(props) => {
    if (props.description) {
      return `
            font-size: var(--styledTableContentFontSize);
            line-height: 1.6;
            color: var(--acolor);
            font-weight: 700;
            text-align: justify;

            .flex-table-cell-content {
                font-weight: 500;
            }
            @media (max-width: 767px) {
                font-size: 1rem;
                line-height: 1.5;
                font-weight: 600;
                flex-wrap: wrap;
            }
            `;
    } else if (props.right) {
      return `
      text-align: right !important;
      `;
    } else if (props.left) {
      return `
      text-align: left !important;

      @media(max-width: 767px){
        text-align: right !important;
      }
      `;
    }
  }};
`;

export const StyledTableHeading = styled.div.attrs({
  className: "flex-table-cell-heading",
})``;

export const TextPage = styled.div.attrs((props) => ({
  className: props.terms ? "terms" : "",
}))`
  max-width: 100%;
  line-height: 14px;
  color: var(--acolor);
  text-align: center;
  //text-align-last: left;
  margin: ${({ newsPub }) =>
    newsPub
      ? "0rem auto"
      : isMobile
        ? "var(--textPageMobileMargin)"
        : "var(--textPageMargin)"};
  /* padding-left: 40px;
    padding-right: 40px; */

  a {
    text-decoration: underline;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
    text-align: center;
    padding: ${({ theme }) =>
      theme.skin === "abc" ||
      theme.skin === "nbc" ||
      theme.skin === "yet" ||
      theme.skin === "fun"
        ? "10px 6px !important"
        : ""};
    color: ${({ theme, news }) =>
      theme.skin === "abc"
        ? news
          ? ""
          : "#96a0b5 !important"
        : theme.skin === "fun" && news
          ? "#fff !important"
          : ""};
    background-color: ${({ news }) =>
      news ? "var(--textPageABgColorNews)" : "var(--textPageABgColor)"};
    :hover {
      color: ${({ theme, news }) =>
        theme.skin === "abc" ? (news ? "" : "#CF1F2C !important") : ""};
    }
  }
  .flex {
    display: flex;
    margin-bottom: 40px;
    align-items: flex-end;
  }

  ol,
  ul {
    padding-left: 0;
    list-style-position: inside;
  }
  li {
    display: list-item;
  }
  &.terms {
    ol,
    ul {
      margin-left: 20px;
      list-style-position: outside;
    }
    li {
      display: list-item !important;
      padding: 5px 10px;
    }
    ol:before {
      font-size: 15px;
    }
  }
  li,
  p {
    font-size: 14px;
    font-weight: var(--textPageLiPFontWeight);
    line-height: 25px;
    color: var(--textPageLiPColor);
    text-align: justify;
    display: table-row;
    text-align-last: left;

    &.question {
      //for faq page
      font-weight: 600;
    }
  }
  h2 {
    display: flex;
    flex-direction: row;
    width: var(--textPageH2Width);
    margin-top: 50px;
    font-size: 25px;
    font-weight: var(--textPageH2FontWeight);
    line-height: 30px;
    text-align: left;
    color: ${({ payments }) =>
      payments ? "var(--textPageH2PaymentsColor)" : "var(--textPageH2Color)"};
    text-transform: uppercase;
    margin-bottom: 40px;
  }
  h2:after {
    content: "";
    flex: 1 1;
    border-bottom: var(--textPageH2AfterBorderBottom);
    margin-bottom: 0;
    color: var(--textPageH2AfterColor);
  }
  @media (min-width: 576px) {
    h2 {
      font-size: 30px;
      margin-top: var(--textPageH2MediaMarginTop);
      letter-spacing: var(--textPageH2MediaLetterSpacing);
    }
    h3 {
      color: var(--textPageH3Color);
      font-size: 1.6rem;
      padding: 2rem;
    }
    li,
    p {
      font-size: 20px;
      font-weight: 500;
      line-height: var(--textPageMediaLiLineHeight);
      color: var(--textPageLiPColor);
      text-align: justify;
    }
  }
  @media (max-width: 767px) {
    padding: ${({ newsPub }) => (newsPub ? "0.5rem" : "1rem")};
    margin: ${({ news, theme }) =>
      news && theme.skin === "qbc" ? "0 auto" : ""};
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    padding: 0 2rem;
    max-width: 100%;
  }
  /* @media (min-width: 1680px) {
    padding: 0px;
    margin-bottom: 100px;

    li,
    p {
      .question {
        line-height: 60px;
      }
    }
  } */
`;

export const PreviousBonusWrapper = styled.div.attrs((props) => ({
  className: `flex-table-row p-3 `,
}))`
  justify-content: ${isMobileOnly &&
  "var(--previousBonusWrapperJustifyContent)"};

  @media screen and (orientation: landscape) {
    justify-content: ${isMobileOnly &&
    "var(--previousBonusWrapperJustifyContentLandscape)"};
  }
`;

export const BonusDescription = styled.div.attrs({
  className:
    "col-xs-12 col-md-8 col-lg-8 d-flex flex-column justify-content-between description my-3",
})`
  text-align: var(--bonusDescriptionTextAlign);
`;

export const StyledProgress = styled.div.attrs({
  className: "my-3",
})`
  display: flex;
  height: $progress-height;
  overflow: hidden; // force rounded corners by cropping it
  @include font-size($progress-font-size);
  background-color: $progress-bg;
  @include border-radius($progress-border-radius);
  @include box-shadow($progress-box-shadow);
`;

export const BonusCol = styled.div.attrs((props) => ({
  className: props.smaller
    ? "col-xs-12 col-md-4 col-lg-4"
    : "col-xs-12 col-md-12 col-lg-9",
}))``;

export const AboutContainer = styled.div.attrs((props) => ({
  className: "d-flex",
}))``;

export const StyledPageHeaderWrapper = styled.div.attrs({
  className: "d-inline-block bg-warning",
})`
  width: 50%;
  text-align: ${({ right }) => (right ? "right" : "")};

  @media (max-width: 767px) {
    width: 100%;
  }
  a:hover {
    background-color: var(--styledPageHeaderWrapperAHoverBg);
  }
  .btn {
    background-color: transparent;
  }
`;
export const StyledPageHeader = styled.h3`
  text-align: left;
  font-size: 2rem;
  height: 100%;
  font-weight: 900;
  color: var(--acolor) !important;

  padding: 0.75rem 0;
  margin: 0;
  text-transform: var(--styledPageHeaderTextTransform);
  line-height: inherit;

  @media (max-width: 767px) {
    padding: 2rem 0;
    font-size: 1.7rem !important;
  }
`;

export const StyledColOffset = styled.div.attrs({
  className: "col-md-6 col-sm-12 offset-md-3",
})``;
export const CashbackHeader = styled.h1`
  color: var(--acolor);
  text-align: left;
  font-size: 2rem;
  margin: 30px 0;
  font-weight: 900;
  text-transform: var(--cashbackHeaderTextTransform);

  @media (max-width: 926px) {
    margin-top: 0;
  }
`;

export const StyledAccountUl = styled.ul.attrs({
  className: "nav mt-3 justify-content-between",
})``;

export const StyledAccountLi = styled.li.attrs({
  className: "nav-item",
})``;

export const StyledAccountNavLink = styled(NavLink).attrs({
  className: "nav-item",
})`
  font-family: var(--styledAccountNavLinkFontFamily);
  ${(props) => {
    if (props.theme.skin === "rac") {
      return `
        cursor: pointer;
        text-transform: capitalize;
        padding-left: 0;
        color: var(--labelcolor);
        font-weight: 700;
        display: block;
        padding: 0.5rem 1rem;
        &.active {
          color: var(--mainmenu);
      }
      
      `;
    }
  }}
`;

export const StyledTerms = styled.div`
  ol,
  ul {
    margin-left: 20px;
    list-style-position: outside;
  }
  li {
    display: list-item !important;
    padding: 5px 10px;
  }
  ol:before {
    font-size: 15px;
  }
`;

export const DepositTransactionWrapper = styled.div`
  background: var(--profileHeaderBgABC);
`;

export const AttachmentImg = styled.div`
  width: 50vh;
  position: absolute;
  z-index: ${({ tournaments }) => (tournaments ? "4" : "1")};
  left: ${({ left }) => left && "-30vh"};
  right: ${({ right }) => right && "-30vh"};
  top: ${({ left, lobby }) => left && (lobby ? "" : "100px")};
  bottom: ${({ right, lobby }) => right && (lobby ? "" : "100px")};
  opacity: ${({ lobby }) => (lobby ? "1" : "0.3")};

  .st0 {
    fill: ${({ theme }) => (theme.current === "light" ? "#f5fafd" : "#030d31")};
  }
  .st1 {
    fill: ${({ theme }) => (theme.current === "light" ? "#e4e7ec" : "#0A174B")};
  }
  .st2 {
    fill: ${({ theme }) => (theme.current === "light" ? "#e4e7ec" : "#0A174B")};
  }
  @media (max-width: 1024px) {
    width: 50vh;
  }
  svg {
    height: ${isMobileOnly ? "70vh" : "100%"};
    width: ${isMobileOnly && "100%"};
  }
`;
export const AboutImgWrapper = styled.div`
  text-align: center;
  padding: 1rem 0;

  img {
    height: 50px;
  }
`;

export const VerificationRACWrapper = styled.div.attrs({
  className: "border rounded mt-3 p-4",
})``;

export const TournamentsWrapper = styled.div`
  display: flex;
  margin: 2rem 0;
`;

export const TournamentsHeader = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: ${isMobileOnly ? "wrap" : ""};
`;

export const TournamentsFlex = styled.div`
  width: ${isMobileOnly ? "100%" : "50%"};
  padding: ${isMobileOnly ? "1rem 0" : ""};
  color: var(--tournamentsFlexColor);

  select {
    background-color: var(--tournamentsFlexSelectBg);
    color: var(--tournamentsFlexColor);
    width: 100% !important;
    height: 100%;
    text-align-last: left;
    padding: 0.75rem 0.75rem;
    direction: ltr;
    :focus {
      background-color: var(--tournamentsFlexSelectBg);
      color: var(--tournamentsFlexColor);
    }
    option {
      text-align: center;
      background-color: var(--tournamentsFlexSelectBg);
      color: var(--tournamentsFlexColor);
    }
  }
  h4 {
    color: var(--tournamentsFlexColor);
    text-transform: capitalize;
    line-height: 1;
    font-weight: 400;
  }
  :first-child {
    text-align: left;
  }
  :last-child {
    height: ${isMobileOnly ? "" : "calc(2.25em + 1.4rem)"};
    display: flex;
    justify-content: ${isMobileOnly ? "center" : "end"};

    button {
      margin-left: 1rem;
      min-width: 100px;
      border-radius: var(--tournamentsFlexButtonBorderRadius);
    }

    div {
      width: ${isMobileOnly ? "70%" : "50%"};
    }
    text-align: right;
  }
`;

export const TournamentsBody = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: ${isMobileOnly ? "wrap" : ""};
`;
export const TournamentsBodyCard = styled.div`
  width: ${isMobileOnly ? "100%" : "32%"};
  margin: ${({ secondStyle }) =>
    isMobileOnly &&
    (secondStyle ? "1rem 0" : "var(--tournamentsBodyCardMargin)")};
  height: ${({ extra }) => (extra ? "450px" : "125px")};
  border: ${({ secondStyle, abc }) =>
    abc
      ? "2px solid var(--tournamentsBorderABCpast)"
      : secondStyle
        ? "var(--tournamentsBodyCardBorderSecondStyle)"
        : "var(--tournamentsBodyCardBorder)"};
  border-radius: ${({ secondStyle, leaderboardSecondStyle }) =>
    secondStyle || leaderboardSecondStyle
      ? "30px"
      : "var(--tournamentsBodyCardBorderRadius)"};
  border-bottom: ${() =>
    isMobileOnly && "var(--tournamentsBodyCardBorderBottom)"};
  display: flex;
  /* align-items: center; */
  flex-wrap: ${({ extra }) => extra && "wrap"};
  background-color: ${({ previous, leaderboardSecondStyle }) =>
    previous
      ? "var(--torunamentPastCardBg)"
      : leaderboardSecondStyle
        ? "var(--tournamentsBodyCardLeaderboardBg)"
        : "var(--tournamentsBodyCardBg)"};
  overflow: ${({ secondStyle, leaderboardSecondStyle }) =>
    !leaderboardSecondStyle && !secondStyle
      ? "var(--tournamentsBodyCardOverflow)"
      : "auto"};
  padding: ${({ previous, leaderboardSecondStyle }) =>
    (previous || leaderboardSecondStyle) && "1rem"};
  margin: ${({ leaderboardSecondStyle }) => leaderboardSecondStyle && "auto"};
  justify-content: center;
  -webkit-mask-image: linear-gradient(to bottom, #000 100%, transparent);
  mask-image: linear-gradient(to bottom, #000 100%, transparent);

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--tournamentsBodyCardScrollbarThumbColor);
    border-radius: 5px;
    border: 0px solid var(--scrollbarBG);
  }
`;

export const TournamentsBodyInfo = styled.div`
  background-color: var(--tournamentBodyInfo);
  width: 100%;
  border-radius: var(--tournamentsBodyInfoBorderRadius);
  display: flex;
  justify-content: var(--tournamentsBodyInfoJustifyContent);
  flex-wrap: ${isMobileOnly && "var(--tournamentsBodyInfoFlexWrap)"};
`;

export const TournamentsBodyCardContent = styled.div`
  width: ${({ leftcol, rightcol }) =>
    leftcol ? "40%" : rightcol ? "60%" : "50%"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--tournamentsBodyCardContentColor);
  border-right: ${!isMobile && "var(--tournamentsBodyCardContentBorderRight)"};
  margin: var(--tournamentsBodyCardContentMargin);
  p {
    margin-bottom: 0;
    color: var(--tournamentsBodyCardContentPColor);
  }
`;

export const TournamentsBodyCardDate = styled.div`
  text-align: var(--tournamentsBodyCardDateTextAlign);
  :first-child {
    width: 30%;
    font-size: 42px;
  }
  :last-child {
    width: var(--tournamentsBodyCardDateLastChildWidth);
    font-size: 1rem;
    line-height: 1;
  }
`;

export const StyledAllPrizes = styled.div`
  width: 50%;
  font-size: var(--styledAllPrizesFontSize);
  font-weight: 600;
`;

export const TournamentsDot = styled.div`
  height: 10px;
  width: 10px;
  margin-right: 0.5rem;
  background-color: ${({ red, green, gold, silver, bronze, gray, rest }) => {
    if (red) return `#ff5500`;
    if (green) return `#1fff00`;
    if (gold) return `#ffd64c`;
    if (silver) return `#8a8a8a`;
    if (bronze) return `#9b6e54`;
    if (gray) return `#44547a`;
    if (rest) return rest;
  }};
  border-radius: 50%;
  display: inline-block;
`;

export const StyledMoneyBag = styled(MoneyBag)`
  width: var(--styledMoneyBagWidth);
  margin-right: 0.5rem;
  display: inline-block;
  .mon1 {
    fill: var(--tournamentMoneyBag);
  }
`;

export const StyledCalendarGreen = styled(CalendarGreen)`
  display: inline-block;
  width: 50px;
`;

export const StyledCalendarRed = styled(CalendarRed)`
  margin-right: 0.5rem;
  display: inline-block;
  width: 50px;
`;

export const PrizePoolWrapper = styled.div`
  width: 100%;
  height: 125px;
  display: flex;
  flex-wrap: nowrap;
  background-color: var(--prizePoolWrapperBgColor);
  border-radius: 9px 9px 0 0;
`;

export const PrizePoolWrapperSecondStyle = styled.div`
  width: 100%;
  display: flex;
  margin: 2rem 0;
  justify-content: space-between;
  flex-wrap: ${isMobileOnly ? "wrap" : ""};
`;

export const PrizePoolSecondStyle = styled.div`
  display: flex;
  border-radius: var(--prizePoolSecondStyleBorderRadius);
  background-color: var(--inputbgABC);
  padding: 0.6rem;
  margin: ${isMobileOnly ? "5px" : ""};
  div {
    :nth-child(2) {
      padding-left: 10px;
    }
  }
  /* div {
  } */
`;

export const PrizePool = styled.div`
  display: flex;
  width: 90%;
  flex-wrap: wrap;
  border-bottom: ${({ extraFont }) =>
    extraFont ? "" : "1px solid var(--tournamentsBorder)"};
  margin: auto;
  text-align: left;
  justify-content: space-between;
  height: 60px;
  font-size: ${({ extraFont }) => (extraFont ? "1.3rem" : "14px")};
  font-weight: ${({ extraFont }) => extraFont && "600"};
  text-transform: ${({ extraFont }) =>
    extraFont ? "uppercase" : "capitalize"};
  color: var(--prizePoolColor);
  align-content: center;

  :first-child {
    height: 100px;
  }
  :last-child {
    border: none;
  }
  h4 {
    color: var(--prizePoolColor);
    text-transform: capitalize;
    line-height: 1;
    font-weight: 400;
    font-size: 14px;
  }
`;

export const TournamentGameDescription = styled.div`
  width: ${({ secondStyle }) => (isMobile || secondStyle ? "100%" : "64%")};
  margin: var(--tournamentGameDescriptionMargin);
  border-bottom: 1px solid var(--tournamentsBorder);
  text-align: left;
  position: ${!isMobile && "var(--tournamentGameDescriptionPosition)"};
  top: -200px;
  color: var(--tournamentDescriptionColor);
  h2 {
    color: var(--tournamentGameDescriptionH2Color);
    font-size: 20px;
  }
  div {
    min-height: 120px;
    padding-bottom: 4rem;
  }
`;
export const TournamentRules = styled.div`
  width: ${({ secondStyle }) => (isMobile || secondStyle ? "100%" : "100%")};
  margin: 1rem 0;
  text-align: left;
  color: var(--tournamentDescriptionColor);
  position: ${({ secondStyle }) => (isMobile || secondStyle ? "" : "relative")};
  top: -150px;
  display: flex;
  flex-wrap: ${isMobileOnly && "wrap"};
  flex-direction: ${isMobileOnly && "column-reverse"};
  h2 {
    color: var(--tournamentRulesColor);
    font-size: 20px;
  }
  p {
    color: var(--tournamentRulesColor);
  }
`;
export const TournamentRulesDiv = styled.div`
  width: ${({ secondStyle }) => (isMobile || secondStyle ? "100%" : "68%")};
  p {
    color: var(--tournamentRulesColor);
  }
`;

export const PreviousTournamentsWrapper = styled.div`
  width: var(--previousTournamentsWrapperWidth);
  margin: var(--previousTournamentsWrapperMargin);
  border-radius: var(--previousTournamentsWrapperBorderRadius);
  min-height: 700px;
  background-color: var(--tournamentPastBg);
  -webkit-mask-image: linear-gradient(to bottom, #000 100%, transparent);
  mask-image: linear-gradient(to bottom, #000 100%, transparent);
`;

export const PreviousTournamentsHeader = styled.h3.attrs({
  className: "container",
})`
  color: var(--previousTournamentsHeaderColor);
  text-align: var(--previousTournamentsHeaderTextAlign);
  padding-top: 4rem;
`;

export const PreviousTournamentsCardWapper = styled.div.attrs({
  className: "container",
})`
  display: flex;
  color: #fff;
  justify-content: space-between;
  font-size: 16px;
  margin: 4rem auto;
  flex-wrap: wrap;
`;

export const RacDivSeparator = styled.div`
  background-color: transparent;
  height: 150px;
  z-index: 1;
`;

export const RacMarketingNotifications = styled.div`
  display: flex;
  padding-top: 1rem;
  width: ${isMobileOnly ? "100%" : "15%"};
  padding-bottom: 2rem;
`;

export const BoxingWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  max-width: 100%;
  background: #000;
  margin: 3rem 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const SwitchBonusesWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 1rem 0;
  padding: 1rem 0;
  border-bottom: 1px solid var(--tournamentsBorder);
`;

export const BonusButton = styled.button`
  background-color: transparent;
  border: none;
  color: var(--acolor);
  font-size: 1rem;
  text-decoration: ${({ active, sports }) =>
    active &&
    `underline 3px ${sports ? "var(--sportsbonuses)" : "var(--casinobonuses)"}`};
  text-underline-offset: 8px;
  cursor: pointer;
`;

export const SpecialLine = styled.div`
  height: 5px;
  background: linear-gradient(to right, #392b28, transparent);
  margin: 0 10px;
  width: 40%;
  display: ${isMobileOnly && "none"};
`;
